import C from '../actionTypes';

export const leaderboardList = (state = [], action) => {
    switch (action.type) {
        case C.LEADERBOARD_REQUEST:
            return state;
        case C.LEADERBOARD_SUCCESS:
            return action.leaderboard;
        case C.LEADERBOARD_FAILURE:
            return state;
        default :
            return state
    }
};

export const userLeadership = (state = {}, action) => {
    switch (action.type) {
        case C.LEADERBOARD_REQUEST:
            return state;
        case C.LEADERBOARD_SUCCESS:
            return action.header;
        case C.LEADERBOARD_FAILURE:
            return state;
        default :
            return state
    }
};